import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Subawards',
      type: 'table',
      watch: {
        '[]': [
          {
            '{}': {
              alias: 'sr.save-subaward',
            },
          },
        ],
      },
      content: {
        '{}': {
          count: {
            '`': {
              selection: {
                '#': {
                  '@': 'subawards',
                },
              },
              subqueries: {
                subawards: {
                  target: 'ent:!subawards:!subaward',
                },
              },
            },
          },
          query: {
            '`': {
              target: 'ent:!subawards:!subaward',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      code: {
                        '{}': {
                          value: {
                            '@.': '!code',
                          },
                        },
                      },
                      name: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      descr: {
                        '{}': {
                          value: {
                            '@.': '!descr',
                          },
                        },
                      },
                      subrecipientName: {
                        '{}': {
                          value: {
                            '@>': [
                              {
                                '@': 'subrecipient',
                              },
                              'name',
                            ],
                          },
                        },
                      },
                      admin_contact: {
                        '{}': {
                          value: {
                            '@.': '!admin_contact',
                          },
                        },
                      },
                      fin_contact: {
                        '{}': {
                          value: {
                            '@.': '!fin_contact',
                          },
                        },
                      },
                      invoice_contact: {
                        '{}': {
                          value: {
                            '@.': '!invoice_contact',
                          },
                        },
                      },
                      authorized_contact: {
                        '{}': {
                          value: {
                            '@.': '!authorized_contact',
                          },
                        },
                      },
                      budget_period: {
                        '{}': {
                          value: {
                            '@.': '!budget_period',
                          },
                        },
                      },
                      curr_amount: {
                        '{}': {
                          value: {
                            '@.': '!curr_amount',
                          },
                        },
                      },
                      total_amount: {
                        '{}': {
                          value: {
                            '@.': '!total_amount',
                          },
                        },
                      },
                      perf_address: {
                        '{}': {
                          value: {
                            '@.': '!perf_address',
                          },
                        },
                      },
                      admin_address: {
                        '{}': {
                          value: {
                            '@.': '!admin_address',
                          },
                        },
                      },
                      pay_address: {
                        '{}': {
                          value: {
                            '@.': '!pay_address',
                          },
                        },
                      },
                      is_ammend: {
                        '{}': {
                          value: {
                            '@.': '!is_ammend',
                          },
                        },
                      },
                    },
                  },
                  onEdit: {
                    '{}': {
                      action: {
                        '{}': {
                          payload: {
                            '{}': {
                              widget: {
                                '{}': {
                                  alias: 'sr.subawards.widgets.edit-subawards',
                                },
                              },
                              variables: {
                                '{}': {
                                  subawardId: {
                                    '@.': '!id',
                                  },
                                },
                              },
                            },
                          },
                          operation: 'ui.modal',
                        },
                      },
                    },
                  },
                  onClick: {
                    '{}': {
                      action: {
                        '{}': {
                          payload: {
                            '{}': {
                              goto: {
                                '{}': {
                                  variables: {
                                    '{}': {
                                      subawardId: {
                                        '@.': '!id',
                                      },
                                    },
                                  },
                                  navigationId: 'subaward-details',
                                },
                              },
                            },
                          },
                          operation: 'ui.navigate',
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                subrecipient: {
                  ref: {
                    attr: 'attr:ent#!subawards#!subaward:!subrecip',
                  },
                  target: 'ent:!subrecips:!subrecip',
                  selection: {
                    '{}': {
                      name: {
                        '@.': '!name',
                      },
                    },
                  },
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'code',
                  dmsAttr: {
                    '{}': {
                      attributeId: 'attr:ent#!subawards#!subaward:!code',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'name',
                  dmsAttr: {
                    '{}': {
                      attributeId: 'attr:ent#!subawards#!subaward:!name',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'descr',
                  dmsAttr: {
                    '{}': {
                      attributeId: 'attr:ent#!subawards#!subaward:!descr',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'subrecipientName',
                  direct: {
                    '{}': {
                      name: 'Subrecipient',
                      type: 'TEXT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'admin_contact',
                  dmsAttr: {
                    '{}': {
                      attributeId:
                        'attr:ent#!subawards#!subaward:!admin_contact',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'fin_contact',
                  dmsAttr: {
                    '{}': {
                      attributeId: 'attr:ent#!subawards#!subaward:!fin_contact',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'invoice_contact',
                  dmsAttr: {
                    '{}': {
                      attributeId:
                        'attr:ent#!subawards#!subaward:!invoice_contact',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'authorized_contact',
                  dmsAttr: {
                    '{}': {
                      attributeId:
                        'attr:ent#!subawards#!subaward:!authorized_contact',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'budget_period',
                  dmsAttr: {
                    '{}': {
                      attributeId:
                        'attr:ent#!subawards#!subaward:!budget_period',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'curr_amount',
                  dmsAttr: {
                    '{}': {
                      attributeId: 'attr:ent#!subawards#!subaward:!curr_amount',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'total_amount',
                  dmsAttr: {
                    '{}': {
                      attributeId:
                        'attr:ent#!subawards#!subaward:!total_amount',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'perf_address',
                  dmsAttr: {
                    '{}': {
                      attributeId:
                        'attr:ent#!subawards#!subaward:!perf_address',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'admin_address',
                  dmsAttr: {
                    '{}': {
                      attributeId:
                        'attr:ent#!subawards#!subaward:!admin_address',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'pay_address',
                  dmsAttr: {
                    '{}': {
                      attributeId: 'attr:ent#!subawards#!subaward:!pay_address',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'is_ammend',
                  dmsAttr: {
                    '{}': {
                      attributeId: 'attr:ent#!subawards#!subaward:!is_ammend',
                    },
                  },
                },
              },
            ],
          },
          onCreate: {
            '{}': {
              action: {
                '{}': {
                  payload: {
                    '{}': {
                      widget: {
                        '{}': {
                          alias: 'sr.subawards.widgets.edit-subawards',
                        },
                      },
                    },
                  },
                  operation: 'ui.modal',
                },
              },
            },
          },
        },
      },
    },
  },
}
